<div>
    <div class="no-product-modal">
        <img class="text-centered preserved-ratio-image"
             src="https://file.personifyhealth.com/api/file/WrXTQmMoRZqPzNsASHiy"
             alt="" />
        <div class="background-clr-white text-container">
            <div class="no-product-title" [translate]="'NotUsedToSee'"></div>
            <div class="no-product-text" [translate]="'OrganizationNotUsingProgram'"></div>
            <div class="no-product-btn-container">
                <a (click)="logout()">
                    <button vpg-button
                            class="vp-button vp-button-primary no-product-button"
                            [translate]="'SignOut'"
                            [variant]="'primary'"
                            [size]="'medium'">
                    </button>
                </a>
            </div>
        </div>
    </div>
</div>